export default [
    // {
    //     name: 'Intro',
    //     stories: null
    // },
    { // 1
        name: 'recruit',
        stories: [
        [

            {
                slug: 'your-application',
                theme: 'two-photo',
                title: 'Your <br>Application',
                body: [
                    'We know that looking for a new role is exciting, and it’s sometimes stressful and time-consuming. So, we’ve created an application process that we believe is <strong>quick</strong>, <strong>fair</strong>, and <strong>consistent</strong> for all candidates. Take a peek at it on our careers site (<a class="inner-link" href="https://phh.tbe.taleo.net/phh01/ats/careers/v2/jobSearch?org=GRANTTHORNTON&cws=56" target="_blank" rel="noopener">Experienced</a> & <a class="inner-link" href="https://phh.tbe.taleo.net/phh01/ats/careers/v2/jobSearch?org=GRANTTHORNTON&cws=57" target="_blank" rel="noopener">Campus</a>). We encourage and welcome applications from everyone.',
                    'We advertise broadly (digital, in-person, print etc.) to reach as many potential candidates as possible. And, if a position requires a post-secondary degree, it doesn’t need to come from a specific school. We love the passion people have about their alma maters and <strong>we value them all</strong>, equally.',
                    'Do you have an accommodation need during the recruitment process? No problem. Let us know and we’ll work to meet your needs.'
                ],
                author: {
                    name: 'Omar Elshafey',
                    job: 'Consultant, Talent Attraction'
                },
                images: [
                    {
                        media: 'Omar_Elshafey',
                        type: 'image'
                    },
                    {
                        media: 'Completing_Your_Application',
                        type: 'image'
                    },
                ],
                nav: {
                    next: 'human-connection-over-ai'
                }
            },
    
        ], [

        {
            slug: 'human-connection-over-ai',
            theme: 'two-photo',
            title: 'Human Connection <br>over AI',
            body: [
                'We love technology, but we love human connection even more. That’s why we don’t leverage Artificial Intelligence at any point in the recruitment process. Every application, resume and digital interview is reviewed by a real person. <strong>We never replace your name with a number, code, or anonymize your information.</strong> We don’t want you to hide your true self – we want you to be authentically you. ',

                '<strong>What else does the Talent Attraction team do?</strong>',
                
                {
                    type: 'list',
                    items: [
                        'We complete formal unconscious bias training every year',
                        'We strive to present candidates who represent the diversity of our communities to hiring managers',
                        'We have open and honest conversations about equity, diversity, inclusion and belonging in our recruiting processes',
                    ]
                },
            ],
            author: {
                name: 'Delfina Mussa',
                job: 'Senior Consultant, Talent Attraction'
            },
            images: [
                {
                    media: 'Delfina_Mussa_2',
                    type: 'image'
                },
                {
                    media: 'Human_Connection',
                    type: 'image'
                }
            ],
            nav: {
                prev: 'your-application',
                next: 'our-assessment-process'
            }
        },

        ], [

        {
            slug: 'our-assessment-process',
            theme: 'two-photo',
            title: 'Our <br>Assessment <br>Process',
            body: [
                'If you’re asked to complete a digital interview or skills assessment, you should know that you’ll get <strong>asked the same questions</strong> and have the <strong>same amount of time to prepare and deliver your answers</strong> as other candidates for that role.',
                'For in-person interviews we begin with standard questions for all candidates. We also recognize that an in-person interview is a little different – it’s real people talking to real people. Each person’s answers might spark different follow-up questions or conversations. Whichever format you experience, <strong>all interviews and assessments are viewed by real people</strong> who use standardized rubrics to assess your answers.',
                'The in-person interview is also your chance to get to know us more as an organization, learn about our culture, and ask as many questions as you’d like – and it’s our chance to get to know you a little better, too.'
            ],
            author: {
                name: 'Areeba Khan',
                job: 'Senior Consultant, Talent Attraction'
            },
            images: [
                {
                    media: 'Areeba_Khan_2',
                    type: 'image'
                },
                {
                    media: 'Standardized_Assessments',
                    type: 'image'
                }
            ],
            nav: {
                prev: 'human-connection-over-ai',
                next: 'your-interview-experience'
            }
        },

        ], [

        {
            slug: 'your-interview-experience',
            theme: 'two-photo',
            title: 'Your <br>Interview <br>Experience',
            body: [
                `Our hiring managers receive <strong>interview training</strong> and use <strong>standardized methods to assess</strong> all our candidates – and we ask them to complete a formal Unconscious Bias training course, too. We’re <strong>open and transparent</strong> in our interviews because we want to make sure you’ll thrive in our environment. We want you to have all the information you need to make the best decision for yourself. Whatever questions you have, know that <strong>we’ll answer honestly</strong>.`,
                `And don’t worry, we won’t ask you questions like "How many ping-pong balls can you fit into a Boeing 747?”`,
                `Do you have an accommodation need during the recruitment process? No problem. Let us know and we’ll work to meet your needs.`,
            ],
            author: {
                name: 'Abby lerullo',
                job: 'Consultant, Talent Attraction [Campus]'
            },
            images: [
                {
                    media: 'Abby_lerullo',
                    type: 'image'
                },
                {
                    media: 'Consistent_Interview_Mathodology',
                    type: 'image'
                },
            ],
            nav: {
                prev: 'our-assessment-process',
                next: 'authentic-connection-and-trust'
            }
        },

        ], [

        {
            slug: 'authentic-connection-and-trust',
            theme: 'two-photo',
            title: 'Authentic <br>Connection & Trust',
            body: [
                'We <strong>value everyone’s unique experiences</strong>, whether most of your career has been in Canada or abroad, and we want our colleagues to bring their whole selves to work. We love <strong>diversity of thought</strong> and encourage our people to <strong>share perspectives</strong> to help our clients, colleagues, and communities thrive. At Doane Grant Thornton we have strong connections built on trust. That’s why our vision is to make a meaningful difference, one relationship at a time.',
            ],
            author: {
                name: 'Grace Yeh',
                job: 'Manager, Talent Attraction [Campus]'
            },
            images: [
                {
                    media: 'Grace_Yeh_2',
                    type: 'image'
                },
                {
                    media: 'Your_Authenticity',
                    type: 'image'
                }
            ],
            nav: {
                prev: 'your-interview-experience',
            }
        },

        ],

        ]
    }, // 1

    { // 2
        name: 'recruit',
        stories: [
        [

        {
            slug: 'personalized-feedback',
            theme: 'two-photo',
            title: 'Personalized <br>Feedback',
            body: [
                '<strong>Whenever possible, a recruiter will give you personalized feedback</strong> throughout the interview process.',
                'While we can’t hire every great candidate we meet along the way, we strive to share information that can be helpful going forward.',
            ],
            author: {
                name: 'Khemwattie Hurry',
                job: 'Senior Consultant, Talent Attraction'
            },
            images: [
                {
                    media: 'Khemwattie_Hurry',
                    type: 'image'
                },
                {
                    media: 'Personalized_Feedback',
                    type: 'image'
                }
            ],
            nav: {
                next: 'we-are-listening'
            }
        },

        ], [

        {
            slug: 'we-are-listening',
            theme: 'slider',
            title: `We're Listening`,
            body: [
                'We want to hear about your experience throughout your recruitment journey and provide opportunities for you to give us feedback about your experience. One of the ways we collect feedback is through anonymous surveys where you can <strong>share your thoughts</strong>.',
                'We regularly review survey results to continue to improve candidates’ experiences. Based on 2022 survey results, <strong>almost 90%</strong> of candidates believed their experience was inclusive.'
            ],
            author: {
                name: 'Allen Wang',
                job: 'Manager, Talent Attraction'
            },
            images: [
                {
                    media: 'Allen_Wang_2',
                    type: 'image'
                },
                ...repeatableImagesList('Our_Cluture_Of_Continuous_Feedback', 5)
            ],
            nav: {
                prev: 'personalized-feedback',
                next: 'our-diverse-backgrounds'
            }
        },

        ], [

        {
            slug: 'our-diverse-backgrounds',
            theme: 'one-photo',
            title: 'Our Diverse <br>Backgrounds',
            author: {
                name: 'Talent Attraction',
            },
            body: [
                'We have a team of highly <strong>skilled recruiters with diverse backgrounds</strong> who speak many languages and have decades of collective recruiting <strong>experience across many different industries and countries</strong>. And while we can’t speak every language, we do whatever we can to help candidates feel welcome, seen, and heard.',
                'We’re <strong>passionate about learning</strong> from each other’s life experiences and that’s one way we continue to grow our understanding of diversity and inclusion.',

                {
                    type: 'router-link',
                    target: '_blank',
                    title: 'Read profiles of, and learn more about, members of our',
                    text: 'Talent Attraction Team.',
                    path: '/connect-with-us/'
                },
            ],
            images: [
                {
                    media: 'Talent_Attraction',
                    type: 'image'
                }
            ],
            nav: {
                prev: 'we-are-listening',
                next: '$$$'
            }
        },

        ], [

        {
            slug: '$$$',
            theme: 'two-photo',
            title: '$$$',
            body: [
                'We’re committed to ensuring fair and competitive compensation practices. Our Firm actively participates in competitive compensation surveys; and we engage third party compensation experts to help us ensure that our salary administration processes are <strong>fair and equitable</strong> from both an internal perspective, as well as an external market perspective.',
            ],
            author: {
                name: 'Merle Freedman',
                fullName: 'Merle Freedman-Fox',
                job: 'Senior Manager, Talent Attraction'
            },
            images: [
                {
                    media: 'Merle_Freedman',
                    type: 'image'
                },
                {
                    media: 'Comprehensive_Total_Rewards',
                    type: 'image'
                },
            ],
            nav: {
                prev: 'our-diverse-backgrounds',
                next: 'a-place-to-belong'
            }
        },

        ], [

        {
            slug: 'a-place-to-belong',
            theme: 'two-photo',
            title: 'A Place <br>to Belong',
            body: [
                `We have about 3,000 colleagues across Canada, each with their own unique lives and career experiences that make them who they are today. We want our people to show their authentic selves. That's why the profiles, photos, and videos on our careers website are of Doane GT colleagues. You'll see our culture come to life in stories from our people.`,
                
                {
                    type: 'router-link',
                    target: '_blank',
                    title: 'Get to know the Doane Grant Thornton Culture a little more at ',
                    text: 'Discover Your Purple.',
                    path: '/'
                },
            ],
            author: {
                name: 'Joanne Leung',
                job: 'Senior Consultant, Talent Attraction'
            },
            images: [
                {
                    media: 'Joanne_Leung_2',
                    type: 'image'
                },
                {
                    media: 'Our_Authenticity',
                    type: 'image'
                }
            ],
            nav: {
                prev: '$$$',
                next: 'create-your-own-story'
            }
        },

        ], [

        {
            slug: 'create-your-own-story',
            theme: 'one-photo',
            title: 'Create Your <br>Own Story',
            author: {
                name: 'Own Story',
            },
            body: [
                'From building innovative solutions, to helping colleagues excel, to making a real difference in your community – at Doane Grant Thornton you’ll have the <strong>opportunity to have an amazing life fuelled by a rewarding career.</strong>',
                'Imagine loving where you work!',
                {
                    type: 'buttons',
                    target: '_blank',
                },
            ],
            images: [
                {
                    media: 'Michelle_Diaz',
                    type: 'image'
                },
                {
                    media: 'Nicole_Lucas',
                    type: 'image'
                },
            ],
            nav: {
                prev: 'our-authenticity'
            }
        },
    
        ]

        ]
    }, // 2
]

function repeatableImagesList(mediaName, itemsLen = 3, divider = '_') {
    return Array.from({length: itemsLen}).map((x, d) => {
        return {
            media: `${mediaName}${divider}${(d + 1)}`,
            type: 'image'
        }
    })
}
